module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "headline pb-5"
  }, [_vm._v("Invoice Sent History")]), _vm._v(" "), _c('v-card-text', [(_vm.activityData) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [(_vm.showEditActions) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateActivity()
      }
    }
  }, [_vm._v("Save Changes")]) : _vm._e(), _vm._v(" "), (_vm.showEditActions) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelEdit()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Date Time")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Invoice Sent")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Remark")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activityData), function(activity, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(_vm.formatTime(activity.timestamp)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(activity.amount)))]), _vm._v(" "), _c('td', [(activity.remarksEdit === false) ? _c('div', {
            on: {
              "click": function($event) {
                return _vm.openEditItem(activity, 'remarks', 'activityData')
              }
            }
          }, [_vm._v("\n                      " + _vm._s(activity.remarks || '') + "\n                      "), _c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "warning",
              "x-small": ""
            }
          }, [_vm._v("edit")])], 1) : _c('div', [_c('div', {
            staticClass: "mt-2"
          }, [_c('v-textarea', {
            attrs: {
              "placeholder": "",
              "outlined": "",
              "dense": "",
              "rows": "2"
            },
            model: {
              value: (activity.remarks),
              callback: function($$v) {
                _vm.$set(activity, "remarks", $$v)
              },
              expression: "activity.remarks"
            }
          })], 1)])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 3784600236)
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63825de1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/MasterLists/InvoiceSentActivityModal.vue
// module id = 2157
// module chunks = 0